import { getTimezoneOffset, owaDate } from 'owa-datetime';
import TimeConstants from 'owa-datetime-utils/lib/TimeConstants';

const overflowWidth = 10;

/**
 * Calculates the neccessary width (in px) of the timestrip headers based on the provided time zones
 *
 * @param timeZoneIds Time zones used to calculate width
 */
export default function getTimeStripWidth(timeZoneIds: string[], baseWidth: number): number {
    let timeStripWidth = baseWidth;

    if (timeZoneIds && timeZoneIds.length > 1) {
        for (let i = 0; i < timeZoneIds.length; i++) {
            const offset = getTimezoneOffset(owaDate(timeZoneIds[i], undefined));

            if (offset % TimeConstants.MinutesInOneHour != 0) {
                timeStripWidth = baseWidth + overflowWidth;
                break;
            }
        }
    }

    return timeStripWidth;
}
